enum ChangeMatchDayActionType {
    INCREMENT = 'INCREMENT',
    DECREMENT = 'DECREMENT',
    UPDATE = 'UPDATE',
    RESET = 'RESET'
}

export { ChangeMatchDayActionType };